var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeritsColored = function SvgMeritsColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#fff",
    strokeWidth: 1.92,
    d: "M21.787 1.923a3.57 3.57 0 0 0-3.574 0l-14.706 8.49a3.57 3.57 0 0 0-1.788 3.096v16.982c0 1.277.682 2.457 1.788 3.095l14.706 8.49a3.57 3.57 0 0 0 3.574 0l14.706-8.49a3.57 3.57 0 0 0 1.788-3.095V13.509a3.57 3.57 0 0 0-1.788-3.095z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M18.693 2.755a2.61 2.61 0 0 1 2.614 0l14.706 8.49a2.61 2.61 0 0 1 1.308 2.264v16.982c0 .934-.499 1.797-1.308 2.264l-14.706 8.49a2.61 2.61 0 0 1-2.614 0l-14.706-8.49a2.61 2.61 0 0 1-1.308-2.265V13.51c0-.935.499-1.798 1.308-2.265z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.33 15.164c0-.643-.522-1.164-1.164-1.164h-1.111c-.643 0-1.164.521-1.164 1.164v1.006c0 .642-.521 1.163-1.164 1.163h-.563c-.643 0-1.164.521-1.164 1.164v10.34c0 .642.521 1.163 1.164 1.163h1.11c.643 0 1.164-.521 1.164-1.164V18.497c0-.643.521-1.164 1.164-1.164h.564c.642 0 1.163-.52 1.163-1.163v-1.006Zm6.899 0c0-.643-.521-1.164-1.164-1.164h-1.11c-.643 0-1.164.521-1.164 1.164v1.006c0 .642.52 1.163 1.163 1.163h.444c.643 0 1.164.521 1.164 1.164v10.34c0 .642.52 1.163 1.163 1.163h1.111C27.48 30 28 29.479 28 28.836v-10.34c0-.642-.521-1.163-1.164-1.163h-.443a1.164 1.164 0 0 1-1.164-1.163zm-3.486 6.38c0-.642-.521-1.163-1.164-1.163h-1.11c-.643 0-1.164.521-1.164 1.164v4.149c0 .642.52 1.163 1.163 1.163h1.111c.643 0 1.164-.52 1.164-1.163z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20,
    x2: 20,
    y1: 2,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C5282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20,
    x2: 20,
    y1: 2,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C5F1"
  })))));
};
export default SvgMeritsColored;